// Copyright (c) 2022 by Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const DEBOUNCE_DELAY = 300
export const DEFAULT_BUTTON_TEXT = 'Szukaj'
export const DEFAULT_MIN_VALUE_LENGTH = 3
export const DEFAULT_SEARCH_INPUT_NAME = 'searchInput'
export const DEFAULT_SEARCH_INPUT_PLACEHOLDER = 'Szukana fraza'
export const DEFAULT_SEARCH_INPUT_VALUE = ''

export const KEY_CODES = { ENTER: 13, ESCAPE: 27 }
